<template>
  <div>
<!--     <hrms-staappr   :staappr='detail.tab1.staappr'
                    :nowLang="nowLang"
                    :currentDtereq="currentDtereq"
                    :currentNumseq="currentNumseq"
                    :currentCodempid="currentCodempid" /> -->

    <div class="box-tab">
    <div id="accordion">
      <div class="panel box-collapse border-color-skin" >
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab1" >
          <h3 class="box-title">
            <i class="fa fa-envelope margin-r-5 margin-r-5"></i>{{ labels['HRMS6KEC2']['20'] }}
          </h3>
        </div>
        <div id="tab1" class="panel-collapse collapse in tab-detail" >
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-xs-12 col-lg-10 clear-padding-lr">
                  <div class="col-xs-12 col-sm-6 col-lg-4 clearfix">
                    <div class="form-group clearfix">
                      <label>{{ labels['HRMS6KEC2']['10'] }}</label>
                      <div class="form-control readonly-field-color">{{ indexSelected.numotgen }}</div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-4 clearfix">
                    <div class="form-group clearfix">
                      <label>{{ labels['HRMS6KEC2']['30'] }} <span class="red">*</span></label>
                                        <!-- :disabled="!validateStaappr || !validateProcess" -->
                      <hrms-datepicker  v-model="detail.tab1.dtereq"
                                        :disabled="true"
                                        v-validate="'required|date_format:DD/MM/YYYY'"
                                        data-vv-value-path="inputDate"
                                        name="dtereq"
                                        :has-error="errors.has('dtereq')" />
                      <div class="text-error" v-show="errors.has('dtereq')">{{errors.first('dtereq')}}</div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-4 clearfix">
                    <div class="form-group clearfix">
                      <label>{{ labels['HRMS6KEC2']['40'] }}</label>
                      <hrms-lov-codcomp v-model="detail.tab1.codcomp"
                                       :nowLang="nowLang"
                                       name="codcomp"
                                       :disabled="!validateProcess"
                                       :descDisp="false" />
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-4 clearfix">
                    <div class="form-group clearfix">
                      <label>{{ labels['HRMS6KEC2']['50'] }}</label>
                      <hrms-lov v-model="detail.tab1.codcalen"
                                lovType="codcalen"
                                :disabled="!validateProcess"
                                :nowLang="nowLang"
                                name="codcalen" />
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-4 clearfix">
                    <div class="form-group clearfix">
                      <label>{{ labels['HRMS6KEC2']['55'] }}</label>
                      <hrms-lov v-model="detail.tab1.codshift"
                                lovType="codshift"
                                :disabled="!validateProcess"
                                :nowLang="nowLang"
                                name="codshift" />
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-lg-4 clearfix">
                    <div class="row">
                      <div class="col-xs-8 codempid-left">
                        <div class="form-group clearfix">
                          <label>{{ labels['HRMS6KEC1']['20'] }}</label>
                          <hrms-lov v-model="detail.tab1.codempid"
                                    lovType="codempid"
                                    :disabled="!validateProcess"
                                    :nowLang="nowLang"
                                    name="codempid"
                                    v-validate="validateCodempidQuery"
                                    :has-error="errors.has('codempid')" />
                          <div class="text-error" v-show="errors.has('codempid')">{{errors.first('codempid')}}</div>
                        </div>
                      </div>
                      <div class="col-xs-4 codempid-right">
                        <div class="form-group clearfix">
                          <button type="button" value="Save" class="btn bg-color-skin" @click="callProcessCodempid()" :disabled="!validateProcess">
                            <i class="fa fa-plus-circle"></i>{{ labelsButton['add'] }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-xs-12 col-md-6 col-lg-5">
                  <div class="row">
                    <div class="col-xs-12">
                      <h4 class="page-header">{{ labels['HRES6KEC2']['20'] }} <span class="red">*</span></h4>
                      <div class="row">
                        <div class="col-xs-6 col-ms-6 col-sm-6">
                          <div class="form-group clearfix">
                            <label>{{ labels['HRES6KEC2']['30'] }} <span class="red">*</span></label>
                            <hrms-datepicker  v-model="detail.tab1.dtestrt"
                                              :disabled="!validateStaappr || !validateProcess"
                                              v-validate="'required|date_format:DD/MM/YYYY|before:dteend'"
                                              data-vv-value-path="inputDate"
                                              name="dtestrt"
                                              :has-error="errors.has('dtestrt')" />
                            <div class="text-error" v-show="errors.has('dtestrt')">{{errors.first('dtestrt')}}</div>
                          </div>
                        </div>
                        <div class="col-xs-6 col-ms-6 col-sm-6">
                          <div class="form-group clearfix">
                            <label>{{ labels['HRES6KEC2']['40'] }} <span class="red">*</span></label>
                            <hrms-datepicker  v-model="detail.tab1.dteend"
                                              :disabled="!validateStaappr || !validateProcess"
                                              v-validate="'required|date_format:DD/MM/YYYY|after:dtestrt'"
                                              data-vv-value-path="inputDate"
                                              name="dteend"
                                              :has-error="errors.has('dteend')" />
                            <div class="text-error" v-show="errors.has('dteend')">{{errors.first('dteend')}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12">
                      <h4 class="page-header">{{ labels['HRES6KEC2']['50'] }} <span class="red">*</span></h4>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group clearfix">
                            <div class="row">
                              <div class="col-xs-6">
                                <label>{{ labels['HRES6KEC2']['60'] }}</label>
                                <hrms-timepicker  v-model="detail.tab1.timbstr"
                                                  :disabled="!validateStaappr || !validateProcess"
                                                  v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbend|date_format:HH:mm'"
                                                  data-vv-value-path="inputTime"
                                                  name="timbstr"
                                                  :has-error="errors.has('timbstr')" />
                                <div class="text-error" v-show="errors.has('timbstr')">{{errors.first('timbstr')}}</div>
                              </div>
                              <div class="col-xs-6">
                                <label>&nbsp;</label>
                                <span class="pull-left" style="margin-top:30px; margin-left:-15px; ">-</span>
                                <hrms-timepicker  v-model="detail.tab1.timbend"
                                                  :disabled="!validateStaappr || !validateProcess"
                                                  v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbstr|date_format:HH:mm'"
                                                  data-vv-value-path="inputTime"
                                                  name="timbend"
                                                  :has-error="errors.has('timbend')" />
                                <div class="text-error" v-show="errors.has('timbend')">{{errors.first('timbend')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group clearfix">
                            <div class="row">
                              <div class="col-xs-6">
                                <label>{{ labels['HRES6KEC2']['70'] }}</label>
                                <hrms-timepicker  v-model="detail.tab1.timdstr"
                                                  :disabled="!validateStaappr || !validateProcess"
                                                  v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdend|date_format:HH:mm'"
                                                  data-vv-value-path="inputTime"
                                                  name="timdstr"
                                                  :has-error="errors.has('timdstr')" />
                                <div class="text-error" v-show="errors.has('timdstr')">{{errors.first('timdstr')}}</div>
                              </div>

                              <div class="col-xs-6">
                                <label>&nbsp;</label>
                                <span class="pull-left" style="margin-top:30px; margin-left:-15px; ">-</span>
                                <hrms-timepicker  v-model="detail.tab1.timdend"
                                                  :disabled="!validateStaappr || !validateProcess"
                                                  v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdstr|date_format:HH:mm'"
                                                  data-vv-value-path="inputTime"
                                                  name="timdend"
                                                  :has-error="errors.has('timdend')" />
                                <div class="text-error" v-show="errors.has('timdend')">{{errors.first('timdend')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group clearfix">
                            <div class="row">
                              <div class="col-xs-6">
                                <label>{{ labels['HRES6KEC2']['80'] }}</label>
                                <hrms-timepicker  v-model="detail.tab1.timastr"
                                                  :disabled="!validateStaappr || !validateProcess"
                                                  v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timaend|date_format:HH:mm'"
                                                  data-vv-value-path="inputTime"
                                                  name="timastr"
                                                  :has-error="errors.has('timastr')" />
                                <div class="text-error" v-show="errors.has('timastr')">{{errors.first('timastr')}}</div>
                              </div>
                              <div class="col-xs-6">
                                <label>&nbsp;</label>
                                <span class="pull-left" style="margin-top:30px; margin-left:-15px; ">-</span>
                                <hrms-timepicker  v-model="detail.tab1.timaend"
                                                  :disabled="!validateStaappr || !validateProcess"
                                                  v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timastr|date_format:HH:mm'"
                                                  data-vv-value-path="inputTime"
                                                  name="timaend"
                                                  :has-error="errors.has('timaend')" />
                                <div class="text-error" v-show="errors.has('timaend')">{{errors.first('timaend')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-md-6 col-lg-5">
                  <div class="row">
                    <div class="col-xs-12 panel-codrem">
                      <div class="form-group clearfix">
                          <label>{{ labels['HRES6KEC2']['90'] }} <span class="red">*</span></label>
                          <hrms-dropdown  v-model="detail.tab1.codrem"
                                          :options="arrCodrem[nowLang]"
                                          :disabled="!validateStaappr || !validateProcess"
                                          v-validate="'required'"
                                          data-vv-value-path="inputValue"
                                          data-vv-name="codrem"
                                          :has-error="errors.has('codrem')" />
                          <div class="text-error" v-show="errors.has('codrem')">{{errors.first('codrem')}}</div>
                      </div>
                    </div>
                    <div class="col-xs-12 panel-remark">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRES6KEC2']['95'] }} <span class="red">*</span></label>
                            <textarea v-validate="'required|max:200'"
                                      v-model="detail.tab1.remark"
                                      name="remark"
                                      maxlength="200"
                                      :class="{ 'form-control' : true, 'input-error' : errors.has('remark') }"
                                      :disabled="!validateStaappr || !validateProcess"></textarea>
                            <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                            <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 panel-remark">
                        <div class="form-group clearfix">
                            <label>{{ labels['HRMS6KEC2']['150'] }}</label>
                            <div class="form-control readonly-field-color">{{ detail.tab1.codinput }} {{ detail.tab1.name_codinput }}</div>
                        </div>
                    </div>

                  </div>
                </div>
              </div>
              <div align="right">
                <button type="button" class="btn bg-color-skin" @click="callProcess()" :disabled="!validateProcess"
                 ><i class="fa fa-spinner"></i> {{ labelsButton['process'] }}</button>
              </div>
              <!-- <div align="right">
                <button type="button" class="btn bg-color-skin" @click="callProcess()" :disabled="eventBtn === 'edit'"
                data-toggle="collapse" data-target="#tab2" ><i class="fa fa-spinner"></i> {{ labelsButton['process'] }}</button>
              </div> -->

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin" >
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab2" ref="detailTab2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS6KEC3']['10'] }}
          </h3>
        </div>

        <div id="tab2" class="panel-collapse collapse tab-detail"  >
          <div class="panel-body">
            <hrms-table :columns="detailTab2Table"
                        :data="detail.tab2"
                        :addInlineEventBool="true"
                        :editInlineEventBool="true"
                        :deleteInlineEventBool="true"
                        :deleteInlineBtnDisp="false"
                        :saveInlineEvent="callSaveTab2"
                        :columnEvent="columnEvent"
                        :saveInlineBtnDisp="false"
                        @setLoadingParentBool="loadingParentBool = arguments[0]"
                        :loadingParentBool="loadingParentBool"
                        ref="detailTab2Table"  />

          </div>
        </div>
      </div>
<!-- {{detail.tab2}} -->
    </div>
    <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
        <!-- <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button> -->
        <button type="button" class="btn bg-color-skin" @click="postDetailSaveAll()" v-if="validateStaappr"
         value="Save"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
  </div>


  </div>
</template>

<script>
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms6ke-detail',
  props: [ 'labels',
    'labelsButton',
    'detail',
    'currentDtereq',
    'currentNumseq',
    'currentCodempid',
    'nowLang',
    'toggle',
    'eventBtn',
    'postHrms6keSave',
    'indexSelected',
    'arrCodrem',
    'descCodapp',
    'detailTab2Table',
    'detailTab2InlineData',
    'setDetailInlineData',
    'receivedHrms6keDetailTab2Process',
    'receivedHrms6keDetailTab2ProcessCodempid',
    'receivedHrms6keDetailAddInline',
    'searchIndex'
  ],
  data () {
    return {
      loadingParentBool: false,
      validateCodempidQuery: '',
      flgProcess: false
    }
  },
  computed: {
    validateStaappr () {
      return (this.detail.tab1.staappr !== 'A' && this.detail.tab1.staappr !== 'Y' && this.detail.tab1.staappr !== 'N')
    },
    validateProcess () {
      return (this.flgProcess || this.eventBtn === 'add')
    }
  },
  created () {
    if (typeof this.arrCodrem[this.nowLang][this.detail.tab1.codrem] === 'undefined') {
      this.detail.tab1.codrem = ''
    }
  },
  mount () {
    this.errors.clear()
  },
  watch: {
    'detail.tab1.dtestrt' () {
      this.$validator.validate('dteend', this.detail.tab1.dteend).catch(e => {})
    },
    'detail.tab1.dteend' () {
      this.$validator.validate('dtestrt', this.detail.tab1.dtestrt).catch(e => {})
    },
    'detail.tab1.timbstr' () {
      this.validateRequiredTime('timbend')
    },
    'detail.tab1.timbend' () {
      this.validateRequiredTime('timbstr')
    },
    'detail.tab1.timdstr' () {
      this.validateRequiredTime('timdend')
    },
    'detail.tab1.timdend' () {
      this.validateRequiredTime('timdstr')
    },
    'detail.tab1.timastr' () {
      this.validateRequiredTime('timaend')
    },
    'detail.tab1.timaend' () {
      this.validateRequiredTime('timastr')
    },
    'detail.tab1' () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    },
    'detail' () {
      this.flgProcess = false
      if (typeof this.detail.tab2.rows !== 'undefined') {
        let tmpRowsApprove = this.detail.tab2.rows.filter(function (dataRow) {
          return dataRow.staappr !== 'P'
        })
        if (tmpRowsApprove.length === 0) {
          this.flgProcess = true
        }
      }
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    validateRequiredTime (requiredWhenExistField) {
      this.$validator.validate(requiredWhenExistField, this.detail.tab1[requiredWhenExistField]).catch(e => {})
    },
    columnEvent (eventName, param, event) {
      if ((eventName === 'dtestrt' || eventName === 'codempid') && (event.type === 'change' || event.type === 'focusin')) {
        if (param.codempid !== '' && param.dtestrt !== '') {
          param.dtework = param.dtestrt
          this.receivedHrms6keDetailAddInline(param)
        } else {
          let data = {
            codempid: '',
            desc_codempid: '',
            codshift: '',
            v_staappr: ''
          }
          this.setDetailInlineData({ data: data, param: param })
        }
      }
    },
    callProcess () {
      this.validateCodempidQuery = ''
      this.$nextTick(() => {
        this.$validator.validateAll().then(result => {
          if (result) {
            let processParams = {
              codempid: this.currentCodempid,
              numseq: '' + this.currentNumseq,
              dtereq: this.detail.tab1.dtereq,
              staappr: this.detail.tab1.staappr,
              routeno: this.detail.tab1.routeno,
              dtestrt: this.detail.tab1.dtestrt,
              dteend: this.detail.tab1.dteend,
              timbstr: this.detail.tab1.timbstr.replace(':', ''),
              timbend: this.detail.tab1.timbend.replace(':', ''),
              timdstr: this.detail.tab1.timdstr.replace(':', ''),
              timdend: this.detail.tab1.timdend.replace(':', ''),
              timastr: this.detail.tab1.timastr.replace(':', ''),
              timaend: this.detail.tab1.timaend.replace(':', ''),
              codrem: this.detail.tab1.codrem,
              remark: this.detail.tab1.remark,
              codcomp: this.detail.tab1.codcomp,
              codcalen: this.detail.tab1.codcalen,
              codshift: this.detail.tab1.codshift,
              codempidQuery: this.detail.tab1.codempid
            }
            this.loadingParentBool = true
            this.$refs.detailTab2.click()
            this.receivedHrms6keDetailTab2Process(processParams)
          }
        })
      })
    },
    callProcessCodempid () {
      this.validateCodempidQuery = 'required'
      this.$nextTick(() => {
        this.$validator.validateAll().then(result => {
          if (result) {
            let processParams = {
              codempid: this.currentCodempid,
              numseq: '' + this.currentNumseq,
              dtereq: this.detail.tab1.dtereq,
              staappr: this.detail.tab1.staappr,
              routeno: this.detail.tab1.routeno,
              dtestrt: this.detail.tab1.dtestrt,
              dteend: this.detail.tab1.dteend,
              timbstr: this.detail.tab1.timbstr.replace(':', ''),
              timbend: this.detail.tab1.timbend.replace(':', ''),
              timdstr: this.detail.tab1.timdstr.replace(':', ''),
              timdend: this.detail.tab1.timdend.replace(':', ''),
              timastr: this.detail.tab1.timastr.replace(':', ''),
              timaend: this.detail.tab1.timaend.replace(':', ''),
              codrem: this.detail.tab1.codrem,
              remark: this.detail.tab1.remark,
              codcomp: this.detail.tab1.codcomp,
              codcalen: this.detail.tab1.codcalen,
              codshift: this.detail.tab1.codshift,
              codempidQuery: this.detail.tab1.codempid
            }
            this.loadingParentBool = true
            this.$refs.detailTab2.click()
            this.receivedHrms6keDetailTab2ProcessCodempid(processParams)
          }
        })
      })
    },
    callSaveTab2 (dataRowsHasFlg) {
      if (this.detail.tab2.total === 0) {
        swal({
          title: '', text: constLabels('msgNotChooseEmploy'), type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      } else {
        let detail = {
          numotgen: this.indexSelected.numotgen,
          tab1: {
            codempid: this.currentCodempid,
            numseq: '' + this.currentNumseq,
            dtereq: this.detail.tab1.dtereq,
            staappr: this.detail.tab1.staappr,
            routeno: this.detail.tab1.routeno,
            dtestrt: this.detail.tab1.dtestrt,
            dteend: this.detail.tab1.dteend,
            timbstr: this.detail.tab1.timbstr.replace(':', ''),
            timbend: this.detail.tab1.timbend.replace(':', ''),
            timdstr: this.detail.tab1.timdstr.replace(':', ''),
            timdend: this.detail.tab1.timdend.replace(':', ''),
            timastr: this.detail.tab1.timastr.replace(':', ''),
            timaend: this.detail.tab1.timaend.replace(':', ''),
            codrem: this.detail.tab1.codrem,
            remark: this.detail.tab1.remark,
            codcomp: this.detail.tab1.codcomp,
            codcalen: this.detail.tab1.codcalen,
            codshift: this.detail.tab1.codshift
          },
          tab2: dataRowsHasFlg
        }
        this.postHrms6keSave({
          searchIndex: this.searchIndex,
          detail: detail,
          callback: this
        })
      }
    },
    postDetailSaveAll () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.detailTab2Table.$emit('$saveInlineEventBuiltIn')
        }
      })
    }
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// detail.vue?7aa4754e